import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import parse from 'html-react-parser';
import dynamic from 'next/dynamic';
import CommonCard from '../home/common-card';
const DisplayImage = dynamic(import('@/components/Ui-components/display-image'), {ssr: false});

const CheckTokenCard = (props: any) => {
    const {heading, subheading, data} = props;
    return (
        <Box>
            <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={5}>
                <Typography variant="h1" component="h2" mb={3} fontSize={{xs: 35, sm: 48}} className="font-headers">
                    {heading}
                </Typography>
                <Typography variant="subtitle1" className="font-regular-text">
                    {subheading ? parse(subheading) : ''}
                </Typography>
            </Box>
            <Container maxWidth="md">
                <Grid container justifyContent="center" spacing={3}>
                    {data?.map((item: any, index: number) => (
                        <Grid md={4} sm={5} xs={12} item key={index + 1} className="check-point-grid-wrapper">
                            <CommonCard>
                                <Box textAlign="center">
                                    <DisplayImage src={item.icon} alt={item.heading} priority={true} />
                                    <Typography>{item.heading}</Typography>
                                </Box>
                            </CommonCard>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default memo(CheckTokenCard);
